"use strict";
exports.__esModule = true;
exports.chart_bar_data_Fill = {
  "name": "--pf-chart-bar--data--Fill",
  "value": "#151515",
  "var": "var(--pf-chart-bar--data--Fill, #151515)"
};
exports["default"] = exports.chart_bar_data_Fill;